import { render } from "./fb-mail.svg?vue&type=template&id=c1b74e68"
const script = {}
script.render = render

export default script